module.exports = __webpack_public_path__ + "img/linea-gratuita.047344c3.svg";